import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="content">
          <strong>Workflow</strong> &copy; {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
